import axiosInstance from "../axiosInstance";
import {
    UserCreatePayload,
    UserApiResponse,
    UserApiPagination,
    UserUpdatePayload
} from "../../types/superAdmin/userTypes";

/**
 * Create a new user
 */
export const createUser = async (
    payload: UserCreatePayload
): Promise<UserApiResponse> => {
    const response = await axiosInstance.post<UserApiResponse>(
        "/super-admin/users",
        payload
    );
    return response.data;
};

/**
 * Delete a user by ID
 */
export const deleteUser = async (userId: string): Promise<UserApiResponse> => {
    const response = await axiosInstance.delete<UserApiResponse>(
        `/super-admin/users/${userId}`
    );
    return response.data;
};

/**
 * get all 
 */
export const getUsers = async (params: any): Promise<UserApiPagination> => {
    const response = await axiosInstance.get("/super-admin/users", { params });
    return response.data;
};


export const updateUser = async (userId: string, body: UserUpdatePayload): Promise<UserApiResponse> => {
    const response = await axiosInstance.put(`/super-admin/users/${userId}`, body);
    return response.data;
};
